import { defineMessages } from 'react-intl';

import languages from 'localizations/languages.json';

import { LanguageOption, UserLocale } from './types';

export enum LocalStorageKey {
  homeActiveTab = 'home_active_tab',
}

export const DEFAULT_LOCALE: UserLocale = 'en-US';

export const INTERFACE_LOCALES: UserLocale[] = ['en-US', 'ru'];

export const LANGUAGE_OPTIONS: LanguageOption[] = Object.entries(languages)
  .map(([code, [englishName, nativeName]]) => ({
    value: code,
    label: nativeName,
    searchLabel: `${nativeName} ${englishName} ${code}`,
  }))
  .sort((option, nextOption) =>
    option.label.localeCompare(nextOption.label, DEFAULT_LOCALE),
  );

export enum SliceName {
  auth = 'auth',
  user = 'user',
  users = 'users',
  billing = 'billing',
  organization = 'organization',
  organizations = 'organizations',
  productEditor = 'productEditor',
}

export enum ToothStatus {
  unhealthy = 'unhealthy',
  lowProbability = 'lowProbability',
  treated = 'treated',
  healthy = 'healthy',
  missing = 'missing',
}

export enum ToothIconPathByToothStatus {
  unhealthy = 'Unhealthy',
  lowProbability = 'LowProbability',
  treated = 'Treated',
  healthy = 'Healthy',
}

export enum PrintType {
  blackAndWhite = 'black-and-white',
  colored = 'colored',
}

export const MOLAR_TOOTH_NUMBER = [
  18, 17, 16, 28, 27, 26, 38, 37, 36, 48, 47, 46,
];

export const DEFAULT_MEDICAL_IMAGE_HEIGHT = 140;

export const SUB_IMAGE_CROPPED_CONTEXT_PADDING = 10;

export const LONG_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: '2-digit',
};

export enum ToastErrors {
  errorHeading = 'errorHeading',
}
export const toastErrors = defineMessages<ToastErrors>({
  errorHeading: {
    id: 'error.heading',
    defaultMessage: 'Error',
  },
});

export const BILLING_ZONE_WITHOUT_STRIPE_REGEXP = /cis|israel/i;
